import { createContext } from 'react'

// App-wide contexts

export const CommunityContext = createContext()
export const SurveyQuestionsContext = createContext()
